import React from 'react';

interface AvailableStep {
  [step: number]: JSX.Element;
}

interface Props {
  currentStep: number;
  availableSteps: AvailableStep;
}

const Steps: React.FC<Props> = ({ currentStep, availableSteps }) => availableSteps[currentStep];

export default Steps;
